import { render } from "./CalculationTab.vue?vue&type=template&id=415668e5&scoped=true"
import script from "./CalculationTab.vue?vue&type=script&lang=js"
export * from "./CalculationTab.vue?vue&type=script&lang=js"

import "./CalculationTab.vue?vue&type=style&index=0&id=415668e5&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-415668e5"]])

export default __exports__